import React from "react";
import { Form, Input, DatePicker } from "antd";
import moment from "moment";

const requiredFieldRules = {
  required: true,
  message: "Поле, обязательное для заполнения"
};

const AddAdministratorFields = ({ form }) => {
  const { getFieldDecorator, getFieldValue } = form;
  const age =
    (getFieldValue("adminBirthDate") &&
      moment().diff(moment(getFieldValue("adminBirthDate")), "years")) ||
    "";

  const getFullAge = years => {
    const lastDigit = years
      .toString()
      .split("")
      .pop();
    return years
      ? lastDigit === "1"
        ? `${years} год`
        : lastDigit === "2"
        ? `${years} года`
        : lastDigit === "3"
        ? `${years} года`
        : `${years} лет`
      : "";
  };

  return (
    <div
      className="add-licensee__form"
      style={{ marginBottom: 16, marginTop: 9 }}
    >
      <div className="add-licensee__item">
        <span className="label">Фамилия:</span>
        <Form.Item>
          {getFieldDecorator("adminLastname", {
            rules: [requiredFieldRules]
          })(<Input style={{ width: 368 }} placeholder="Укажите фамилию" />)}
        </Form.Item>
      </div>
      <div className="add-licensee__item">
        <span className="label">Имя:</span>
        <Form.Item>
          {getFieldDecorator("adminName", {
            rules: [requiredFieldRules]
          })(<Input style={{ width: 368 }} placeholder="Укажите имя" />)}
        </Form.Item>
      </div>
      <div className="add-licensee__item">
        <span className="label">Отчество:</span>
        <Form.Item>
          {getFieldDecorator("adminPatronymic")(
            <Input style={{ width: 368 }} placeholder="Укажите отчество" />
          )}
        </Form.Item>
      </div>
      <div className="add-licensee__item">
        <span className="label">Дата рождения:</span>
        <Form.Item>
          {getFieldDecorator("adminBirthDate", {
            rules: [requiredFieldRules]
          })(
            <DatePicker
              format={"DD.MM.YYYY"}
              defaultPickerValue={moment().subtract(18, "years")}
              showToday={false}
              placeholder="ДД.ММ.ГГГГ"
              disabledDate={d => {
                return !moment()
                  .subtract(18, "years")
                  .isAfter(d);
              }}
            />
          )}
        </Form.Item>
        <span
          className="label"
          style={{
            width: "auto",
            paddingLeft: 16
          }}
        >
          {getFullAge(age)}
        </span>
      </div>
      <div className="add-licensee__item">
        <span className="label">E-mail:</span>
        <Form.Item>
          {getFieldDecorator("adminEmail", {
            rules: [
              requiredFieldRules,
              {
                type: "email",
                message: "Не корректный email"
              }
            ]
          })(<Input style={{ width: 368 }} placeholder="Укажите e-mail" />)}
        </Form.Item>
      </div>
    </div>
  );
};

export default AddAdministratorFields;
